import React from "react";
import "./AudioItem.css";

export function AudioItem({ filePath, kwText, enText }) {
  return (
    <div className="audio-item">
      <p>{`${kwText} (${enText})`}</p>
      <audio controls={true} style={{ width: "100%" }} src={filePath}></audio>
    </div>
  );
}
